export default __webpack_public_path__ + "static/media/JMKRIDE_RWU_BlackBG.5ccc83db.svg";